import { createApp } from 'vue';
import ElementPlus from 'element-plus';
// import 'element-plus/lib/theme-chalk/index.css';
import 'element-plus/dist/index.css';
import axios from 'axios';
import emitter from 'tiny-emitter/instance';
import upperFirst from 'lodash/upperFirst';
import camelCase from 'lodash/camelCase';
import { createI18n } from 'vue-i18n';
import App from './App.vue';
import router from './router';
import store from './store';
import baseHub from './hubs/base-hub';
import commonMixins from './mixins/common-mixins';
import { clickOutside } from './directives';
import dates from './plugins/dates';
import './style/main.scss';

axios.interceptors.request.use(request => {
  if (store.state.context.jwtToken) request.headers.Authorization = `Bearer ${store.state.context.jwtToken}`;
  return request;
});
axios.interceptors.response.use(
  response => response,
  error => {
    if (error.response.status === 401) {
      return store
        .dispatch('context/logout')
        .then(() => router.push('/authorization'));
    }
    return Promise.reject(error);
  }
);
// console.log(process.env.API_URL);

axios.defaults.baseURL = process.env.VUE_APP_API_URL;

axios.defaults.withCredentials = true;

function loadLocaleMessages() {
  const locales = require.context(
    './locales',
    true,
    /[A-Za-z0-9-_,\s]+\.json$/i
  );
  const messages = {};
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const [, locale] = matched;
      messages[locale] = locales(key);
    }
  });
  return messages;
}

const i18n = createI18n({
  locale: 'ru',
  fallbackLocale: 'ru',
  messages: loadLocaleMessages()
});

const app = createApp(App);

const icons = require.context(
  './components/icons',
  false,
  /[I,i]con[A-Z]\w+\.(vue|js)$/
);
const navBarIcon = require.context(
  './components/icons/navbarIcon',
  false,
  /[A-Z]\w+\.(vue|js)$/
);
const commonComponents = require.context(
  './components/Common',
  false,
  /[A-Z]\w+\.(vue|js)$/
);
const uiComponents = require.context(
  './components/Common/UI',
  false,
  /[A-Z]\w+\.(vue|js)$/
);
const importComponents = components => {
  components.keys().forEach(fileName => {
    const componentConfig = components(fileName);

    const componentName = upperFirst(
      camelCase(
        fileName
          .split('/')
          .pop()
          .replace(/\.\w+$/, '')
      )
    );
    app.component(componentName, componentConfig.default || componentConfig);
  });
};
importComponents(icons);
importComponents(navBarIcon);
importComponents(commonComponents);
importComponents(uiComponents);

app.config.productionTip = false;
app.config.globalProperties.$http = axios;
app.config.globalProperties.$events = emitter;
app.config.globalProperties.$imageURL = process.env.VUE_APP_API_IMAGE_URL;
app.config.globalProperties.$apiUrl = process.env.VUE_APP_API_URL;
app.use(router);
app.use(store);
app.use(i18n);
app.use(ElementPlus);
app.use(baseHub);
app.use(dates);

app.mixin(commonMixins);
app.directive('click-outside', clickOutside);
app.mount('#app');
